'use client';

import { useAtomValue, useSetAtom } from 'jotai';

import Link from 'next/link';

import { reportsRequestedAtom } from '@core/Atoms/HistoryCheck/HistoryCheck.atom';
import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';
import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import Button from '@gds/Button/Button';
import { useModal } from '@modal/Hooks/UseModal';
import { generateHovTrackingData } from '@tracking/Hov.tracking';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import styles from './VehicleHistoryCta.module.css';
interface Props {
  locale: Locale;
  value: string;
  regNumber: string;
  vehicleId: string;
  strings: Record<string, string>;
}

export const VehicleHistoryCta = ({ locale, value, regNumber, vehicleId, strings }: Props) => {
  const { closeModal } = useModal();
  const reportsRequested = useAtomValue(reportsRequestedAtom);
  const searchParams = useAtomValue(searchParamsAtom);
  const userId = useAtomValue(userIdAtom);
  const formState = useAtomValue(formStateAtom);
  const vehicle = useAtomValue(currentVehicleAtom)!;
  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  const handleRequestBtnClick = () => {
    const {
      hovStart: { event, context },
    } = generateHovTrackingData({
      searchParams,
      userId,
      formState,
      vehicle,
    });
    trackCustomEvent({ event, context });
    toggleLeadForm('history-check');
    closeModal();
  };

  return (
    <>
      {!!reportsRequested?.[regNumber] && !!reportsRequested?.[regNumber]?.email ? (
        <Button
          Component={Link}
          href={`/${locale}/auto/vehicle-history/${vehicleId}`}
          className={styles.cta}
          variant="outlined"
          data-test-id="viewHistoryReportButton"
        >
          {strings.viewReport}
        </Button>
      ) : (
        <Button
          variant="outlined"
          onClick={() => handleRequestBtnClick()}
          data-test-id="requestHistoryCheckButton"
          className={styles.cta}
        >
          {value}
        </Button>
      )}
    </>
  );
};
